<template>
  <div>
    <b-row class="row OTFilterStartEdDate">
      <b-col class="col">
        <otif-dateInput
          v-model="date"
          :validation="validation"
          :invalidMessage="invalidMessage"
          :datePickerOptions="datePickerOptions"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      _parsedDate: null,
      datePickerOptions: {
        format: 'DD/MM/YYYY h:mm:ss A',
        keepInvalid: true,
        useCurrent:true
      }
    };
  },

  props: ["value", "formName", "invalidMessage", "validation"],

  computed: {

    parsedDate: {
      cache: false,
      get() {
        if (!this.value) {
          // return moment().hour(0).minute(0);
        } else {
          return moment(this.value, 'DD/MM/YYYY h:mm:ss A');
        }
      }
    },

    date: {
      cache: false,
      get() {
        if (this.parsedDate) {
          return this.parsedDate.format("DD/MM/YYYY h:mm:ss A");
        }
      },
      set(v) {
        this.eventDate({
          date: v
        });
      }
    },

    hour: {
      get() {
        if (this.parsedDate) {
          const hour = this.parsedDate.hour();

          if (hour > 12) {
            return (hour - 12).toString();
          } else if (hour === 0) {
            return (0).toString();
          } else {
            return hour.toString();
          }
        }
      },
      set(v) {
        this.eventDate({
          hour: parseInt(v)
        });
      }
    },

    minute: {
      get() {
        if (this.parsedDate) {
          return this.parsedDate.minute().toString();
        }
      },
      set(v) {
        this.eventDate({
          minute: parseInt(v)
        });
      }
    },

    meridiem: {
      cache: false,
      get() {
        if (this.parsedDate) {
          const hour = this.parsedDate ? this.parsedDate.hour() : 0;

          if (hour >= 12) {
            return "PM";
          } else {
            return "AM";
          }
        } else {
          return "AM";
        }
      },
      set(v) {
        this.eventDate({
          meridiem: v
        });
      }
    }
  },

  methods: {
    eventDate(opts) {
      if (!opts) {
        opts = {};
      }

      var date = moment();

      var parts;

      if (opts && opts["date"]) {
        parts = moment(opts["date"], 'DD/MM/YYYY h:mm:ss A');
      } else {
        parts = moment(this.date, 'DD/MM/YYYY h:mm:ss A');
      }

      date.year(parts.year());
      date.month(parts.month());
      date.date(parts.date());   
      date.hour(parts.hour());
      date.minute(parts.minute());
      date.seconds(parts.seconds());
      
      

      this.$emit("input", date.format("YYYY-MM-DD[T]HH:mm:ssZZ"));
    }
  },

  
};
</script>

